import { Component , OnInit } from '@angular/core';
import { InternationalAddressValidation } from './international-address.validator';
import { AddressComponent } from '../address-component';
import { ItemList } from 'src/app/_common/constant/item-list';
import { ViewportScroller } from '@angular/common';
import { InputData } from 'src/app/_common/data/input-data';
import { Confirm } from 'src/refresh/service/constant';
import { Util } from 'src/refresh/service/Util';

@Component({
  selector: 'international-address',
  templateUrl: './international-address.component.html',
  styleUrls: ['./international-address.component.less']
})
export class InternationalAddressComponent extends AddressComponent implements OnInit {

      public notEditable:boolean = false;
      constructor( public items:ItemList, private data:InputData, public viewportScroller: ViewportScroller) {
            super();
            
            this.idPrefix = this.getPrefix(); //should be unique for every component created
            this.streetNumberID = this.idPrefix + 'strNumber';
            this.streetNameID = this.idPrefix + 'strName';
            this.unitID = this.idPrefix + 'unit';
            this.poboxID = this.idPrefix + 'pobox';
            this.cityID = this.idPrefix + 'city';
            this.provinceID = this.idPrefix + 'prov';
            this.countryID = this.idPrefix + 'country';  
            this.otherCountryID = this.idPrefix + 'other';            

            this.notEditable = this.data.contact.notEditable;
            this.isCustodyOtherThanParent = this.data.eligibility.isCustodyOtherThanParent == Confirm.YES;
      }

      ngOnInit(): void {
            this.validator = new InternationalAddressValidation(this);       
            if ( Util.isEmpty(this.addr.streetNumber) ) this.addr.streetNumber = "";
      }
}
